function normalizeEmail(value: unknown): string {
    return String(value || '').trim().toLowerCase();
}

export function shouldIsolatePortalInvitationSession(
    invitationEmail: unknown,
    signedInEmail: unknown,
): boolean {
    const invited = normalizeEmail(invitationEmail);
    const active = normalizeEmail(signedInEmail);

    return Boolean(invited && active && invited !== active);
}

export function resolvePortalInvitationDestination(options: {
    clientSlug: string;
    requestedRedirect?: unknown;
}): string {
    const clientSlug = String(options.clientSlug || '').trim();
    const fallback = clientSlug ? `/portal/${encodeURIComponent(clientSlug)}` : '/portal';
    const requestedRedirect = String(options.requestedRedirect || '').trim();

    if (!clientSlug || !requestedRedirect) {
        return fallback;
    }

    try {
        const url = new URL(requestedRedirect, 'https://portal.local');
        const segments = url.pathname.split('/').filter(Boolean);
        const requestedSlug = decodeURIComponent(segments[1] || '');

        if (segments[0] !== 'portal' || requestedSlug !== clientSlug) {
            return fallback;
        }

        return `${url.pathname}${url.search}${url.hash}`;
    } catch {
        return fallback;
    }
}
